<!--
 * @Autor: 毛萍萍
 * @Date: 2021-07-08 19:42:36
 * @LastEditTime: 2021-12-09 16:57:30
 * @LastEditors: wangjx
 * @Description:
 * @FilePath: \scim-edm-web\src\components\private\batch-delete\index.vue
-->
<template>
  <div class="batch-delete__wrap">
    <div class="batch-delete__block--left">
      <p v-if="showBatchDelete" class="batch-delete-item pr24">
        {{$t('common.selectCurrentPage')}}
        <span class="batch-delete--active m2">{{currentSelectNum}}</span>
        /{{(showTotal || pageSize > total) ? total : pageSize}} {{$t('common.term')}}
      </p>
      <p v-else class="batch-delete-item pr24">
        {{$t('common.selectCurrent')}}<span class="batch-delete--active">{{currentSelectNum}}</span>{{$t('common.term')}}
      </p>
      <span v-if="showAllCurrent" class="batch-delete--active pr24 cursor-p" @click="btnClick('currentPageall')">{{$t('common.currentPageSelect')}}{{pageSize > total ? total : pageSize}}{{$t('common.term')}}</span>
      <span v-if="showAllTotal" class="batch-delete--active pr24 cursor-p" @click="btnClick('totalPageall')">{{$t('common.selectAll')}}{{total}}{{$t('common.term')}}</span>
      <span class="batch-delete--active cursor-p" @click="btnClick('resetData')">{{$t('common.empty')}}</span>
    </div>
    <div class="batch-delete__block--right">
      <div class="batch-delete__custom">
        <slot name="batchL"></slot>
        <span v-if="showBatchDelete" class="batch-delete--active cursor-p" @click="btnClick('deleteData')">{{$t('common.deletSelectTerm')}}</span>
        <slot name="batchR"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "BatchDelete",
  components: {},
  props: {
    pageSize: {
      type: Number,
      default: 10
    },
    total: {
      type: Number,
      default: 10
    },
    showTotal: {
      type: Boolean,
      default: false
    },
    showAllCurrent: {
      type: Boolean,
      default: false
    },
    showAllTotal: {
      type: Boolean,
      default: false
    },
    showBatchDelete: {
      type: Boolean,
      default: false
    },
    currentSelectNum: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {
    btnClick(data) {
      this.$emit(data);

      /*
       * this.$emit("optionsChange", {
       *   explain: {
       *     name: "解释返回的参数意义",
       *     currentPageall: "本页全选",
       *     totalPageall: "所有页全选",
       *     resetData: "清空",
       *     deleteData: "批量删除"
       *   },
       *   data
       * });
       */
    }
  }
};
</script>

<style scoped lang="scss">
  .batch-delete__wrap{
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 40px;
    padding: 0 24px;
    margin-bottom: 8px;
    background: $scim-color-table-block;

    .batch-delete-item {
      display: inline-block;
    }

    .batch-delete__block--left {

    }
    .batch-delete__block--right {
      flex: 1;
      text-align: right;
      overflow: hidden;
    }

    .batch-delete--active {
      color: $scim-color-primary;
    }

    .batch-delete__custom {
      display: inline-flex;
      align-items: center;
    }

    .m2 {
      margin: 0 2px;
    }

    .pr24 {
      padding-right: 24px;
    }
  }
</style>
